import * as auth from './auth';
import * as users from './users';
import * as photos from './photos';
import * as groups from './groups';
import * as friends from './friends';

export default {
  auth,
  users,
  photos,
  groups,
  friends,
};
